import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import FieldContainer from '../pure/utils/form/FieldContainer';
import './ReviewTypeSelect.styl';
import SimpleDropdown from 'charts/components/forms/SimpleDropdown';

export default class ReviewTypeSelect extends React.PureComponent {
  render() {
    const {
      coachingReviewTypes = List(),
      onChange,
      reviewTypeId,
      reviewComplete,
      disabled,
    } = this.props;
    if (coachingReviewTypes.isEmpty()) return null;

    // Dont show dropdown for single option
    if (coachingReviewTypes.size === 1 || disabled) {
      const reviewType = reviewTypeId
        ? coachingReviewTypes.find(rt => rt.id === reviewTypeId)
        : coachingReviewTypes.first();

      // This prevents white screen (of death) where, due to timing
      // issues, no review type is found since the reviewTypeId does
      // not yet exist in the coachingReviewTypes. It eventially does
      // exist, and is found, and everything works as expected.
      if (!reviewType) return null;

      return (
        <div className="review-type-select">
          <h4>
            Coaching Meeting Type: <span className="review-type-name">{reviewType.name}</span>
          </h4>
        </div>
      );
    }

    // if complete, show what was used
    if (reviewComplete) {
      const reviewType = coachingReviewTypes.find(rt => rt.id === reviewTypeId);

      return (
        <div className="review-type-select">
          <h4>
            Coaching Meeting Type:{' '}
            <span className="review-type-name">{reviewType ? reviewType.name : ''}</span>
          </h4>
        </div>
      );
    }

    return (
      <div className="review-type-select">
        <FieldContainer
          label="Coaching Meeting Type"
          labelType="div"
          className="coaching-review-type">
          <div className="review-type-dropdown">
            <SimpleDropdown
              selections={coachingReviewTypes.toArray()}
              value={coachingReviewTypes.find(t => t.id === reviewTypeId)}
              onSelect={t => onChange(t.id)}
            />
          </div>
        </FieldContainer>
      </div>
    );
  }
}

ReviewTypeSelect.propTypes = {
  coachingReviewTypes: PropTypes.instanceOf(List), // List<CoachingReviewType>
  reviewTypeId: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  reviewComplete: PropTypes.bool,
};
